<div class="bg-white rounded">
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title">Nuevo Tipo de Aceite</h4>
            <button type="button" class="btn-close" aria-label="Close"
                (click)="activeModal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <form [formGroup]="form">
                <div class="row">
                    <div class="form-group col-12 col-sm-12">
                        <label for="nombre">Nombre Tipo Aceite (*)</label>
                        <input type="nombre" class="form-control" id="nombre" formControlName="nombre"
                            [ngClass]="{'is-invalid': form.controls['nombre'].errors && form.controls['nombre'].touched}">
                        <div class="invalid-feedback">
                            Debe ingresar un valor en el campo
                        </div>
                        <div class="mb-4" *ngIf="!form.controls['nombre'].errors || !form.controls['nombre'].touched">
                        </div>
                    </div>
                </div>
            </form>
            <br>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="guardar()">Registrar</button>
            <button type="button" class="btn btn-danger" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
        </div>
    </div>
</div>